import * as React from "react";

export function GoldCoin(): JSX.Element {
  return (
    <i className="fa fa-circle text-chips-gold" aria-hidden="true"></i>
  );
}
